import _extends from '@babel/runtime/helpers/esm/extends';
import * as React from 'react';

var CancelCircleFill = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12 2a10 10 0 1010 10A10.02 10.02 0 0012 2zm3.625 12.529a.78.78 0 010 1.096.788.788 0 01-1.096 0L12 13.086l-2.529 2.539a.788.788 0 01-1.096 0 .779.779 0 010-1.096L10.914 12 8.375 9.471a.779.779 0 011.096-1.096L12 10.914l2.529-2.539a.779.779 0 011.096 1.096L13.086 12l2.539 2.529z",
    fill: "#888"
  }));
});
CancelCircleFill.displayName = 'CancelCircleFill';

export { CancelCircleFill, CancelCircleFill as default };
